import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  classes?: string;
};

const defaultProps = {
  classes: '',
};

export default function SideScrollList({ children, classes }: Props) {
  return <ul className={`side-scroll-list overflow-x-auto ${classes}`}>{children}</ul>;
}

SideScrollList.defaultProps = defaultProps;
